import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {PAGE_NUM, PAGE_OPTION, PAGE_SIZE} from 'app/constant/constant';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {PaginatorService} from 'data/service/paginator.service';

@Component({
  selector: 'app-lims-paginator',
  templateUrl: './lims-paginator.component.html',
  styleUrls: ['./lims-paginator.component.scss']
})
export class LimsPaginatorComponent implements OnInit, AfterViewInit {

  @Input() length!: number;
  @Input() pageSizeOptions = PAGE_OPTION;
  @Input() id: string;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @Input() pageSize = PAGE_SIZE;
  @Output() pageChange = new EventEmitter<PageEvent>();

  constructor(private paginatorService: PaginatorService) { }

  ngOnInit(): void { }

  onPageChange(event: PageEvent): void {
    this.pageChange.emit(event);
  }
  public resetPage() {
    this.paginator.pageIndex = PAGE_NUM;
    this.paginator.pageSize = this.pageSize;
  }
  ngAfterViewInit(): void {
    this.paginatorService.translatePaginator(this.paginator);
  }

}
